class App {
  constructor() {
    this.preDefinedApps = {
      NETFLIX: "com.netflix.ninja",
      SPOTIFY: "com.spotify.tv.android",
      USB: "com.playmore.filemanager",
      YOUTUBE: "com.google.android.youtube.tv",
      BROWSER: "org.mozilla.tv.firefox"
    }
  }
  async _init() {
    return true
  }

  async getList() {
    try {
      const res = JSON.parse(playmore.platform.getInstalledApps())
      if (!res) return res

      const applist = []
      res.forEach(app => applist.push({ key: app.packageName, value: app.name }))
      applist.push({ key: "com.playmore.filemanager", value: "usb" })
      applist.push({ key: "com.google.android.youtube.tv", value: "youtube" })
      applist.push({ key: "com.google.android.youtube.tvmusic", value: "ytmusic" })
      applist.push({ key: "com.netflix.ninja", value: "netflix" })
      applist.push({ key: "com.amazon.amazonvideo.livingroom", value: "prime" })
      return applist
    } catch (err) {
      return _$.error(err)
    }
  }
  async launch(app_id) {
    if (!app_id) return false
    let promise = await _$.progress.create()

    await __.platform.unfocusing()
    _$.vue.$once("applicationUnfocused", () => promise.resolve())

    /* Library Code */
    let res = false
    if (app_id === "com.playmore.filemanager") res = playmore.platform.openFileManager()
    else res = playmore.platform.openApp(app_id)

    if (!res) promise.reject()

    /* Library Code */

    return promise.done
  }
  async close() {
    let promise = await _$.progress.create()

    _$.vue.$once("applicationFocusing", () => promise.resolve())

    playmore.platform.returnToPlatform()

    return promise.done
  }
  async _middleware(type) {
    const isStandalone = ["DS", "Public"].includes(__.device.get("using_by"))
    if (type === "applicationUnfocused" && isStandalone) playmore.platform.returnToPlatform()
    return true
  }
  async _getAppName() {
    await _$.sleep(500)
    let app = playmore.device
      .runWithSh("dumpsys window windows | grep mActivityRecord", true)
      .split("/")
      .shift()
      .split(" ")
      .pop()

    if (app === "com.playroomtv.playroomstb") return false
    return app
  }
  blockMainApps() {}
}

export default App
